import React from "react";
import useGlobalInfo from '../useGlobalInfo'
import useGlobalHeader from '../useGlobalHeader'
import useGlobalDisplay from '../useGlobalDisplay'
import useInfoStyle from '../useInfoStyle'
import { UpdateParameterValues } from "../services/City";
function LandAnalysis(props) {
  const [value, setValue] = React.useState(null);
  const [ischecked, setchecked] = React.useState(null);
  const [ischecked1, setchecked1] = React.useState(null);
  const [Isinfo, SetIsinfo] = React.useContext(useGlobalInfo);
  const [IsHeader, SetIsHeader] = React.useContext(useGlobalHeader);
  const [IsDisplay, SetIsDisplay] = React.useContext(useGlobalDisplay);
  const [IsStyle, SetStyle] = React.useState("form-control construction");
  const [Isinfostyle, Setinfostyle] = React.useContext(useInfoStyle);

  const [structureType, SetstructureType] = React.useState("Per Home");
  React.useEffect(() => {
    if (props.structureType == "Single Family") { SetstructureType("Per Lot") }
    if (props.structureType == "Apartment" || props.structureType == "Condo") { SetstructureType("Per Unit") }
    if (props.value == "") {
      //  setValue(0);
    }
    else {
      if (props.id == 226 || props.id == 248) {
        setValue(commafy(props.value));
      }
      else {
        setValue(props.value);
      }

    }
    if (props.id == 243) {
      SetStyle("form-control construction leftTop");
    }
    if (props.id == 246) {
      SetStyle("form-control construction ");
    }
    if (props.id == 245 || props.id == 175 || props.id == 248 || props.id == 47) {
      SetStyle("form-control construction ");
    }
    if (props.id == 244) {
      SetStyle("form-control construction RightTop ");
    }
    if (props.id == 247) {
      SetStyle("form-control construction leftBottom");
    }
    if (props.id == 47) {
      SetStyle("form-control construction RightBottom ");
    }
    if (props.id == 226) {
      SetStyle("form-control construction leftTop leftBottom");
    }
    if (props.id == 280) {
      SetStyle("form-control construction RightBottom RightTop Prowidth2");
    }
    if (props.id == 181) {
      SetStyle("form-control  Prowidth2");
    }
    //let val = props.wholeEl.ischecked.slice(1, props.wholeEl.ischecked.length - 1);

    setchecked(props.wholeEl.ischecked === true ? "checked" : false);
    setchecked1(props.wholeEl.ischecked);
  }, []);


  function commafy(num) {
    var str = num.toString().split('.');
    if (str[0].length >= 5) {
      str[0] = str[0].replaceAll(/(\d)(?=(\d{3})+$)/g, '$1,');
    }
    if (str[1] && str[1].length >= 5) {
      str[1] = str[1].replaceAll(/(\d{3})/g, '$1 ');
    }
    return str.join('.');
  }

  const onChange = (e) => {

    setValue(e.target.value);
    let checkid = e.target.id;
    let parameterid = checkid.split('-')[1]
    let structuretype = "";


    setchecked(e.target.checked);
    setchecked1(e.target.checked);

    if (checkid.includes("Single Family")) {
      structuretype = "Single Family"
    }
    if (checkid.includes("Townhome")) {
      structuretype = "Townhome"
    }
    if (checkid.includes("Cottage")) {
      structuretype = "Cottage"
    }
    if (checkid.includes("Rowhouse")) {
      structuretype = "Rowhouse"
    }
    if (checkid.includes("Condo")) {
      structuretype = "Condo"
    }
    if (checkid.includes("Apartment")) {
      structuretype = "Apartment"
    }
    if (checkid.includes("148")) {
      props.object["Land Analysis"].find((item) => item.ParameterId == parameterid && item.structureType == structuretype).ischecked = true;
      props.object["Land Analysis"].find((item) => item.ParameterId == 181 && item.structureType == structuretype).ischecked = false;
      props.object["Land Analysis"].find((item) => item.ParameterId == 45 && item.structureType == structuretype).ischecked = false;
      props.object["Land Analysis"].find((item) => item.ParameterId == 47 && item.structureType == structuretype).ischecked = false;
      props.object["Land Analysis"].find((item) => item.ParameterId == 247 && item.structureType == structuretype).ischecked = false;
      // props.setData({...props.wholeEl,...props.wholeEl.ischecked,ischecked : true,value : value})  
      document.getElementById(structuretype + "-148").style.background = "#e7f0fa";
      document.getElementById(structuretype + "-247").style.background = "#f7fafd";
      document.getElementById(structuretype + "-47").style.background = "#f7fafd";
    }
    if (checkid.includes("45")) {
      props.object["Land Analysis"].find((item) => item.ParameterId == parameterid && item.structureType == structuretype).ischecked = true;
      props.object["Land Analysis"].find((item) => item.ParameterId == 181 && item.structureType == structuretype).ischecked = false;
      props.object["Land Analysis"].find((item) => item.ParameterId == 148 && item.structureType == structuretype).ischecked = false;
      props.object["Land Analysis"].find((item) => item.ParameterId == 47 && item.structureType == structuretype).ischecked = false;
      props.object["Land Analysis"].find((item) => item.ParameterId == 246 && item.structureType == structuretype).ischecked = false;
      document.getElementById(structuretype + "-45").style.background = "#e7f0fa";
      document.getElementById(structuretype + "-246").style.background = "#f7fafd";
      document.getElementById(structuretype + "-181").style.background = "#f7fafd";
    }
    if (checkid.includes("47")) {
      props.object["Land Analysis"].find((item) => item.ParameterId == parameterid && item.structureType == structuretype).ischecked = true;
      props.object["Land Analysis"].find((item) => item.ParameterId == 181 && item.structureType == structuretype).ischecked = false;
      props.object["Land Analysis"].find((item) => item.ParameterId == 45 && item.structureType == structuretype).ischecked = false;
      props.object["Land Analysis"].find((item) => item.ParameterId == 148 && item.structureType == structuretype).ischecked = false;
      props.object["Land Analysis"].find((item) => item.ParameterId == 247 && item.structureType == structuretype).ischecked = false;
      props.object["Land Analysis"].find((item) => item.ParameterId == 247 && item.structureType == structuretype).ischecked = false;
      document.getElementById(structuretype + "-47").style.background = "#e7f0fa";
    }
    if (checkid.includes("181")) {
      props.object["Land Analysis"].find((item) => item.ParameterId == parameterid && item.structureType == structuretype).ischecked = true;
      props.object["Land Analysis"].find((item) => item.ParameterId == 47 && item.structureType == structuretype).ischecked = false;
      props.object["Land Analysis"].find((item) => item.ParameterId == 45 && item.structureType == structuretype).ischecked = false;
      props.object["Land Analysis"].find((item) => item.ParameterId == 148 && item.structureType == structuretype).ischecked = false;
      props.object["Land Analysis"].find((item) => item.ParameterId == 246 && item.structureType == structuretype).ischecked = false;
      document.getElementById(structuretype + "-181").style.background = "#e7f0fa";
      document.getElementById(structuretype + "-246").style.background = "#f7fafd";
      document.getElementById(structuretype + "-45").style.background = "#f7fafd";

    }
    if (checkid.includes("247")) {
      props.object["Land Analysis"].find((item) => item.ParameterId == parameterid && item.structureType == structuretype).ischecked = true;
      props.object["Land Analysis"].find((item) => item.ParameterId == 47 && item.structureType == structuretype).ischecked = false;
      props.object["Land Analysis"].find((item) => item.ParameterId == 148 && item.structureType == structuretype).ischecked = false;
      document.getElementById(structuretype + "-247").style.background = "#e7f0fa";
      document.getElementById(structuretype + "-148").style.background = "#f7fafd";
      document.getElementById(structuretype + "-47").style.background = "#f7fafd";

    }
    if (checkid.includes("226")) {
      props.object["Land Analysis"].find((item) => item.ParameterId == parameterid && item.structureType == structuretype).ischecked = true;
      props.object["Land Analysis"].find((item) => item.ParameterId == 248 && item.structureType == structuretype).ischecked = false;
      props.object["Land Analysis"].find((item) => item.ParameterId == 280 && item.structureType == structuretype).ischecked = false;
      document.getElementById(structuretype + "-226").style.background = "#e7f0fa";
      document.getElementById(structuretype + "-248").style.background = "#f7fafd";
      document.getElementById(structuretype + "-280").style.background = "#f7fafd";
    }
    if (checkid.includes("248")) {
      props.object["Land Analysis"].find((item) => item.ParameterId == parameterid && item.structureType == structuretype).ischecked = true;
      props.object["Land Analysis"].find((item) => item.ParameterId == 226 && item.structureType == structuretype).ischecked = false;
      props.object["Land Analysis"].find((item) => item.ParameterId == 280 && item.structureType == structuretype).ischecked = false;

      document.getElementById(structuretype + "-248").style.background = "#e7f0fa";
      document.getElementById(structuretype + "-226").style.background = "#f7fafd";
      document.getElementById(structuretype + "-280").style.background = "#f7fafd";
    }
    if (checkid.includes("280")) {
      props.object["Land Analysis"].find((item) => item.ParameterId == parameterid && item.structureType == structuretype).ischecked = true;
      props.object["Land Analysis"].find((item) => item.ParameterId == 226 && item.structureType == structuretype).ischecked = false;
      props.object["Land Analysis"].find((item) => item.ParameterId == 248 && item.structureType == structuretype).ischecked = false;

      document.getElementById(structuretype + "-280").style.background = "#e7f0fa";
      document.getElementById(structuretype + "-226").style.background = "#f7fafd";
      document.getElementById(structuretype + "-248").style.background = "#f7fafd";
    }
    if (checkid.includes("246")) {
      props.object["Land Analysis"].find((item) => item.ParameterId == parameterid && item.structureType == structuretype).ischecked = true;
      props.object["Land Analysis"].find((item) => item.ParameterId == 45 && item.structureType == structuretype).ischecked = false;
      props.object["Land Analysis"].find((item) => item.ParameterId == 181 && item.structureType == structuretype).ischecked = false;
      document.getElementById(structuretype + "-246").style.background = "#e7f0fa";
      document.getElementById(structuretype + "-45").style.background = "#f7fafd";
      document.getElementById(structuretype + "-181").style.background = "#f7fafd";

    }
    props.setData({ ...props.wholeEl, value: e.target.value, ischecked: true })
    if (e.target.value != "") {
      UpdateParameterValues(structuretype, props);
      //document.getElementById(e.target.id).value="0";

      //   var formID=Cookies.get('FormID');
      // let newArr =[];
      //   newArr=({
      //    ParameterId: parameterid,ParameterName: props.name,ParameterTypeId:props.ParameterTypeId,value: e.target.value,
      //    ischecked: 1,structureType: structuretype,IsManual: 0,isComplete: 0,perhomevalue: 0,perprojectvalue: 0, ParamOrder: 0,
      //  });

      //  var name=Cookies.get('username');
      //  let params = {
      //   username: name,
      //   Stage:"P",
      //   formId: formID,
      //   userType:"AutoSave",
      //   parameters: []
      //  };
      //  params.StructureTypes=[{
      //   StructureType: structuretype,
      //   Calculations: [newArr],}
      //  ]
      //  params = JSON.stringify({
      //    Body: params,
      //  });
      //  console.log(params)
      //  return axios
      //    .post('https://msbp54qxc1.execute-api.us-west-2.amazonaws.com/Prod/singlefamily', params, {
      //      headers: {
      //        "Content-Type": "application/json",
      //        Accept: "application/json",
      //      },
      //      crossorigin: true,
      //    })
      //    .then((res) => {
      //    // setLoading(false);
      //      return res.data;
      //    })
      //    .catch((e) => {
      //    // setLoading(false);
      //      alert(e.message);
      //    });  
    }

  };

  const onChange1 = (e) => {


    setchecked(e.target.checked);
    setchecked1(e.target.checked);
    props.setData({ ...props.wholeEl, ...props.wholeEl.ischecked, ischecked: e.target.checked, value: value })


  };

  function setPreviousValue(ID) {
    let e = ID.split('-')[1];

    let StructureType = ID.split('-')[0];
    let previuosID = document.getElementById("PreviousID").value;
    let color1 = document.getElementById("color1").value;
    let color2 = document.getElementById("color2").value;
    let color3 = document.getElementById("color3").value;
    if (previuosID == 198) {
      document.getElementById(StructureType + "-198").style.background = color1;
      document.getElementById(StructureType + "-229").style.background = color3;
      if (StructureType == "Townhome" || StructureType == "Cottage" || StructureType == "Rowhouse") {
        document.getElementById(StructureType + "-201").style.background = color2;
      }
      if (StructureType == "Apartment" || StructureType == "Condo") {
        document.getElementById(StructureType + "-202").style.background = color2;
      }
      if (StructureType == "Single Family") {
        document.getElementById(StructureType + "-200").style.background = color2;
      }
    }

    if (previuosID == 186) {
      document.getElementById(StructureType + "-186").style.background = color1;
      document.getElementById(StructureType + "-224").style.background = color3;
      if (StructureType == "Townhome" || StructureType == "Cottage" || StructureType == "Rowhouse") {
        document.getElementById(StructureType + "-208").style.background = color2;
      }
      if (StructureType == "Apartment" || StructureType == "Condo") {
        document.getElementById(StructureType + "-209").style.background = color2;
      }
      if (StructureType == "Single Family") {
        document.getElementById(StructureType + "-223").style.background = color2;
      }
    }
    if (previuosID == 88) {
      document.getElementById(StructureType + "-88").style.background = color1;
      document.getElementById(StructureType + "-238").style.background = color2;
    }
    if (previuosID == 89) {
      document.getElementById(StructureType + "-89").style.background = color1;
      document.getElementById(StructureType + "-237").style.background = color2;
    }
    if (previuosID == 91) {
      document.getElementById(StructureType + "-91").style.background = color1;
      document.getElementById(StructureType + "-236").style.background = color2;
    }
    if (previuosID == 105) {
      document.getElementById(StructureType + "-105").style.background = color1;
      document.getElementById(StructureType + "-235").style.background = color2;
    }
    if (previuosID == 90) {
      document.getElementById(StructureType + "-90").style.background = color1;
      document.getElementById(StructureType + "-234").style.background = color2;
    }
    if (previuosID == 106) {
      document.getElementById(StructureType + "-106").style.background = color1;
      document.getElementById(StructureType + "-233").style.background = color2;
    }
    if (previuosID == 87) {
      document.getElementById(StructureType + "-87").style.background = color1;
      document.getElementById(StructureType + "-232").style.background = color2;
    }
    if (previuosID == 109) {
      document.getElementById(StructureType + "-109").style.background = color1;
      document.getElementById(StructureType + "-97").style.background = color2;
      document.getElementById(StructureType + "-239").style.background = color3;
    }
    if (previuosID == 113) {
      document.getElementById(StructureType + "-113").style.background = color1;
      document.getElementById(StructureType + "-102").style.background = color2;
      document.getElementById(StructureType + "-239").style.background = color3;
    }
    if (previuosID == 114) {
      document.getElementById(StructureType + "-114").style.background = color1;
      document.getElementById(StructureType + "-103").style.background = color2;
      document.getElementById(StructureType + "-239").style.background = color3;
    }
    if (previuosID == 112) {
      document.getElementById(StructureType + "-112").style.background = color1;
      document.getElementById(StructureType + "-100").style.background = color2;
      document.getElementById(StructureType + "-239").style.background = color3;
    }
    if (previuosID == 111) {
      document.getElementById(StructureType + "-111").style.background = color1;
      document.getElementById(StructureType + "-101").style.background = color2;
      document.getElementById(StructureType + "-239").style.background = color3;
    }
    if (previuosID == 110) {
      document.getElementById(StructureType + "-110").style.background = color1;
      document.getElementById(StructureType + "-99").style.background = color2;
      document.getElementById(StructureType + "-239").style.background = color3;
    }

    if (previuosID == 45) {
      document.getElementById(StructureType + "-45").style.background = color1;
      document.getElementById(StructureType + "-246").style.background = color2;
      document.getElementById(StructureType + "-181").style.background = color3;
    }

    if (previuosID == 226) {
      document.getElementById(StructureType + "-280").style.background = color1;
      document.getElementById(StructureType + "-226").style.background = color2;
      document.getElementById(StructureType + "-248").style.background = color3;
    }
    if (previuosID == 256) {
      document.getElementById(StructureType + "-256").style.background = color1;
      document.getElementById(StructureType + "-36").style.background = color2;
      document.getElementById(StructureType + "-258").style.background = color3;
    }
    if (previuosID == 41) {
      document.getElementById(StructureType + "-41").style.background = color1;
      document.getElementById(StructureType + "-259").style.background = color2;
      document.getElementById(StructureType + "-255").style.background = color3;
    }

    if (previuosID == 43) {
      document.getElementById(StructureType + "-43").style.background = color2;
      document.getElementById(StructureType + "-260").style.background = color3;
    }
    if (previuosID == 44) {
      document.getElementById(StructureType + "-44").style.background = color2;
      document.getElementById(StructureType + "-261").style.background = color3;
    }
    if (previuosID == 42) {
      document.getElementById(StructureType + "-42").style.background = color2;
      document.getElementById(StructureType + "-262").style.background = color3;
    }
  }
  function showInfo(ID) {

    let e = ID.split('-')[1];
    Setinfostyle(ID);
    let StructureType = ID.split('-')[0];
    let previuosID = document.getElementById("PreviousID").value;
    if (previuosID != "" && previuosID != null) {
      setPreviousValue(ID);
    }
    document.getElementById(StructureType + "-85").style.background = '#f7f7f7';
    document.getElementById(StructureType + "-86").style.background = '#f7f7f7';
    document.getElementById(StructureType + "-217").style.background = '#f7f7f7';
    if (StructureType !== "Apartment" && StructureType !== "Condo") {
      document.getElementById(StructureType + "-96").style.background = 'transparent';
    }
    if (StructureType == "Apartment" || StructureType == "Condo") {
      document.getElementById(StructureType + "-79").style.background = 'transparent';

      document.getElementById(StructureType + "-71").style.background = '#f7f7f7';
    }

    document.getElementById("PreviousID").value = e;

    if (e == 45) {
      document.getElementById("color1").value = document.getElementById(StructureType + "-45").style.backgroundColor;
      document.getElementById("color2").value = document.getElementById(StructureType + "-246").style.backgroundColor;
      document.getElementById("color3").value = document.getElementById(StructureType + "-181").style.backgroundColor;
      document.getElementById(StructureType + "-45").style.background = '#fffce6';
      document.getElementById(StructureType + "-246").style.background = '#fffce6';
      document.getElementById(StructureType + "-181").style.background = '#fffce6';
    }
    if (e == 226) {
      document.getElementById("color1").value = document.getElementById(StructureType + "-280").style.backgroundColor;
      document.getElementById("color2").value = document.getElementById(StructureType + "-226").style.backgroundColor;
      document.getElementById("color3").value = document.getElementById(StructureType + "-248").style.backgroundColor;
      document.getElementById(StructureType + "-280").style.background = '#fffce6';
      document.getElementById(StructureType + "-226").style.background = '#fffce6';
      document.getElementById(StructureType + "-248").style.background = '#fffce6';
    }

    if (e == 45) {

      document.getElementById("HLand Analysis" + StructureType).innerText = "Desired Profit before Financing";
      document.getElementById("ILand Analysis" + StructureType).innerText = "The desired profit the user intends to make before any financing and/or investor fees and returns.";

      SetIsHeader("Desired Profit before Financing");
      SetIsinfo("The desired profit the user intends to make before any financing and/or investor fees and returns.");
      SetIsDisplay("info");
    }
    if (e == 226) {
      document.getElementById("HLand Analysis" + StructureType).innerText = "Closing Costs";
      document.getElementById("ILand Analysis" + StructureType).innerText = "All the fees associated with the closing of the land acquisition.";

      SetIsHeader("Closing Costs");
      SetIsinfo("All the fees associated with the closing of the land acquisition.");
      SetIsDisplay("info");
    }
    document.getElementById("Proforma Breakdown" + StructureType).style.display = 'none';
    document.getElementById("Building Cost Breakdown" + StructureType).style.display = 'none';
    document.getElementById("Site Potential" + StructureType).style.display = 'none';
    document.getElementById("Sales Cost Breakdown" + StructureType).style.display = 'none';
    document.getElementById("Land Analysis" + StructureType).style.display = 'block';
  }




  if (props.id == 227) {
    return (
      <>
        <div class="row" style={{ marginTop: "5%", borderTop: "1px solid rgba(0, 0, 0, 0.2)", width: "100%" }}>
          <div class="col-md-5" ></div>
          <div class="col-md-3 col-7" style={{ marginTop: "3%" }}>
            <div class="from   justify-content-between  align-items-center ">
              <label class="mr-1 mtop" style={{ marginTop: "5%" }}><u>{props.name.split('Per')[0]} </u>
              </label>



            </div>
          </div>
          <div class="col-md-3 col-5" style={{ marginTop: "3%" }}>
            <div class="test">
              <input
                type="text"
                key={props.structureType + "-" + props.id}
                id={props.structureType + "-" + props.id}
                value={value}
                onChange={onChange}
                //placeholder={props.name.split('Per')[0]}
                readOnly
                class="form-control construction"
                style={{ borderRadius: "5px", fontWeight: "550" }}
              />
            </div>
          </div>
        </div>
        <div class="row" style={{ width: "100%", marginTop: "2%" }}>
          <div class="col-md-11">
            <p style={{ width: "100%", textAlign: "right", fontSize: "small", marginBottom: "0px" }}>Estimated Value - Building Cost - Total Sales Cost - Desired Profit = Land Value

            </p>
            <p style={{ width: "100%", textAlign: "right", fontSize: "small", marginBottom: "0px" }}>Land Value + Closing Cost = Total Land Cost

            </p>
          </div>
        </div>
      </>
    );
  }

  if (props.id == 243 || props.id == 147 || props.id == 244) {
    if (props.id == 243) {
      return (

        <>
          <div class="col-md-12 input-box1 ">
            <div class="row" style={{ width: "100%" }}>
              <div class="col-md-3"></div>
              <div class="col-md-2 col-2"><label class="d-block text-center">Per sqft </label></div>
              <div class="col-md-3 col-5"><label class="d-block text-center">{structureType}</label></div>
              <div class="col-md-3 col-5"><label class="d-block text-center">Project</label></div>
            </div></div>
          <div class="col-md-3" >
            <div class="from   justify-content-between  align-items-center ">
              <label class="mr-1 mtop">{props.name.split('Per')[0]}
              </label>



            </div>
          </div>

          <div class="col-md-2 col-2">
            <div class="from   justify-content-between  align-items-center ">
              <div class="test">
                <input
                  type="text"
                  key={props.structureType + "-" + props.id}
                  id={props.structureType + "-" + props.id}
                  value={value}
                  onChange={onChange}
                  //placeholder={props.name.split('Per')[0]}
                  readOnly
                  class={IsStyle}
                  style={{ borderBottom: "2px solid" }}
                />
              </div>
            </div>
          </div>
        </>
      );
    }
    else {
      return (

        <>


          <div class="col-md-3 col-5">
            <div class="from   justify-content-between  align-items-center ">
              <div class="test">
                <input
                  type="text"
                  key={props.structureType + "-" + props.id}
                  id={props.structureType + "-" + props.id}
                  value={value}
                  onChange={onChange}
                  //placeholder={props.name.split('Per')[0]}
                  readOnly
                  class={IsStyle}
                  style={{ borderBottom: "2px solid" }}
                />
              </div>
            </div>
          </div>
        </>
      );


    }

  }
  if (props.id == 226 || props.id == 248) {
    if (props.id == 226) {

      if (props.ischecked == true) {
        return (

          <>
            <div class="col-md-5" style={{ marginTop: "2%" }}>
              <div class="from   justify-content-between  align-items-center ">
                <label class="mr-1 mtop">- Closing Cost
                  <span class="question" onClick={() => showInfo(props.structureType + "-" + props.id)} > <svg xmlns="http://www.w3.org/2000/svg" width="15.339" height="17" fill="gray" >
                    <path d="M6.749,0A6.749,6.749,0,1,0,13.5,6.749,6.757,6.757,0,0,0,6.749,0Zm0,12.7A5.955,5.955,0,1,1,12.7,6.749,5.961,5.961,0,0,1,6.749,12.7Zm.919-3a.819.819,0,1,1-.819-.819A.82.82,0,0,1,7.669,9.7Zm.8-6.355A1.913,1.913,0,0,1,8.9,4.82,3,3,0,0,1,7.814,6.442,1.6,1.6,0,0,0,7.072,7.75H6.278a2.36,2.36,0,0,1,1-1.9,2.279,2.279,0,0,0,.846-1.214,1.187,1.187,0,0,0-.286-.8,1.2,1.2,0,0,0-.991-.465A1.324,1.324,0,0,0,5.364,4.652L4.57,4.631a2.118,2.118,0,0,1,2.281-2.05,2.017,2.017,0,0,1,1.614.766Z" />
                  </svg></span>

                </label>



              </div>
            </div>
            <div class="col-2 ismobile"></div>
            <div class="col-md-3 col-5" style={{ marginTop: "2%" }}>
              <div class="from   justify-content-between  align-items-center ">
                <div class="test">
                  <input
                    type="text"
                    key={props.structureType + "-" + props.id}
                    id={props.structureType + "-" + props.id}
                    value={value}
                    onChange={onChange}
                    //placeholder={props.name.split('Per')[0]}

                    class={IsStyle}
                    style={{ backgroundColor: "#e7f0fa" }}
                  />
                </div>
              </div>
            </div>
          </>
        );
      } else {
        if (props.ischecked == true) {
          return (

            <>
              <div class="col-md-5" style={{ marginTop: "2%" }}>
                <div class="from   justify-content-between  align-items-center ">
                  <label class="mr-1 mtop">- Closing Cost
                    <span class="question" onClick={() => showInfo(props.structureType + "-" + props.id)} > <svg xmlns="http://www.w3.org/2000/svg" width="15.339" height="17" fill="gray" >
                      <path d="M6.749,0A6.749,6.749,0,1,0,13.5,6.749,6.757,6.757,0,0,0,6.749,0Zm0,12.7A5.955,5.955,0,1,1,12.7,6.749,5.961,5.961,0,0,1,6.749,12.7Zm.919-3a.819.819,0,1,1-.819-.819A.82.82,0,0,1,7.669,9.7Zm.8-6.355A1.913,1.913,0,0,1,8.9,4.82,3,3,0,0,1,7.814,6.442,1.6,1.6,0,0,0,7.072,7.75H6.278a2.36,2.36,0,0,1,1-1.9,2.279,2.279,0,0,0,.846-1.214,1.187,1.187,0,0,0-.286-.8,1.2,1.2,0,0,0-.991-.465A1.324,1.324,0,0,0,5.364,4.652L4.57,4.631a2.118,2.118,0,0,1,2.281-2.05,2.017,2.017,0,0,1,1.614.766Z" />
                    </svg></span>

                  </label>



                </div>
              </div>
              <div class="col-2 ismobile"></div>
              <div class="col-md-3 col-5" style={{ marginTop: "2%" }}>
                <div class="from   justify-content-between  align-items-center ">
                  <div class="test">
                    <input
                      type="text"
                      key={props.structureType + "-" + props.id}
                      id={props.structureType + "-" + props.id}
                      value={value}
                      onChange={onChange}
                      //placeholder={props.name.split('Per')[0]}

                      class={IsStyle}
                      style={{ backgroundColor: "#e7f0fa" }}
                    />
                  </div>
                </div>
              </div>
            </>
          );
        }
        else {

          return (

            <>
              <div class="col-md-5" style={{ marginTop: "2%" }}>
                <div class="from   justify-content-between  align-items-center ">
                  <label class="mr-1 mtop">- Closing Cost
                    <span class="question" onClick={() => showInfo(props.structureType + "-" + props.id)} > <svg xmlns="http://www.w3.org/2000/svg" width="15.339" height="17" fill="gray" >
                      <path d="M6.749,0A6.749,6.749,0,1,0,13.5,6.749,6.757,6.757,0,0,0,6.749,0Zm0,12.7A5.955,5.955,0,1,1,12.7,6.749,5.961,5.961,0,0,1,6.749,12.7Zm.919-3a.819.819,0,1,1-.819-.819A.82.82,0,0,1,7.669,9.7Zm.8-6.355A1.913,1.913,0,0,1,8.9,4.82,3,3,0,0,1,7.814,6.442,1.6,1.6,0,0,0,7.072,7.75H6.278a2.36,2.36,0,0,1,1-1.9,2.279,2.279,0,0,0,.846-1.214,1.187,1.187,0,0,0-.286-.8,1.2,1.2,0,0,0-.991-.465A1.324,1.324,0,0,0,5.364,4.652L4.57,4.631a2.118,2.118,0,0,1,2.281-2.05,2.017,2.017,0,0,1,1.614.766Z" />
                    </svg></span>

                  </label>



                </div>
              </div>
              <div class="col-2 ismobile"></div>
              <div class="col-md-3 col-5" style={{ marginTop: "2%" }}>
                <div class="from   justify-content-between  align-items-center ">
                  <div class="test">
                    <input
                      type="text"
                      key={props.structureType + "-" + props.id}
                      id={props.structureType + "-" + props.id}
                      value={value}
                      onChange={onChange}
                      //placeholder={props.name.split('Per')[0]}

                      class={IsStyle}

                    />
                  </div>
                </div>
              </div>
            </>
          );
        }

      }
    }
    else {
      return (

        <>


          <div class="col-md-2 col" style={{ marginTop: "2%" }}>
            <div class="from   justify-content-between  align-items-center ">
              <div class="test">
                <input
                  type="text"
                  key={props.structureType + "-" + props.id}
                  id={props.structureType + "-" + props.id}
                  value={value}
                  onChange={onChange}
                  //placeholder={props.name.split('Per')[0]}

                  class={IsStyle}

                />
              </div>
            </div>
          </div>
        </>
      );


    }

  }
  if (props.id == 247 || props.id == 148 || props.id == 47) {
    if (props.id == 247) {

      return (

        <>
          <div class="col-md-3 " >
            <div class="from   justify-content-between  align-items-center ">
              <label class="mr-1 mtop"><u>{props.name.split('Per')[0]}</u>
              </label>



            </div>
          </div>

          <div class="col-md-2 col-2">
            <div class="from   justify-content-between  align-items-center ">
              <div class="test">
                <input
                  type="text"
                  key={props.structureType + "-" + props.id}
                  id={props.structureType + "-" + props.id}
                  value={value}
                  onChange={onChange}
                  //placeholder={props.name.split('Per')[0]}
                  style={{ borderTop: "2px solid", fontWeight: "550" }}
                  class={IsStyle}
                  readOnly
                />
              </div>
            </div>
          </div>
        </>
      );
    }
    if (props.id == 47) {

      return (

        <>
          <div class="col-md-3 col-5">
            <div class="from   justify-content-between  align-items-center ">
              <div class="test">
                <input
                  type="text"
                  key={props.structureType + "-" + props.id}
                  id={props.structureType + "-" + props.id}
                  value={value}
                  onChange={onChange}
                  //placeholder={props.name.split('Per')[0]}
                  style={{ borderTop: "2px solid", fontWeight: "550" }}
                  class={IsStyle}

                />
              </div>
            </div>
          </div>
        </>
      );
    }
    else {
      return (

        <>


          <div class="col-md-3 col-5">
            <div class="from   justify-content-between  align-items-center ">
              <div class="test">
                <input
                  type="text"
                  key={props.structureType + "-" + props.id}
                  id={props.structureType + "-" + props.id}
                  value={value}
                  onChange={onChange}
                  //placeholder={props.name.split('Per')[0]}
                  style={{ borderTop: "2px solid", fontWeight: "550" }}
                  class={IsStyle}
                  readOnly
                />
              </div>
            </div>
          </div>
        </>
      );
    }
  }
  else if (props.id == 170 || props.id == 245 || props.id == 172 || props.id == 175 || props.id == 45 || props.id == 246 || props.id == 181 || props.id == 280) {

    if (props.id == 170 || props.id == 172 || props.id == 114 || props.id == 113) {

      return (
        <>
          <div class="col-md-5">
            <div class="from   justify-content-between  align-items-center ">
              <label class="mr-1 mtop">- {props.name.split('Per')[0]}
              </label>
            </div>
          </div>
          <div class="col-2 ismobile"></div>
          <div class="col-md-3 col-5">
            <div class="from   justify-content-between  align-items-center ">
              <div class="test">
                <input

                  type="text"
                  key={props.structureType + "-" + props.id}
                  id={props.structureType + "-" + props.id}
                  value={value}
                  onChange={onChange}
                  //placeholder={props.name.split('Per')[0]}
                  readOnly

                  class={IsStyle}
                />
              </div>
            </div>
          </div>
        </>
      );
    }
    if (props.id == 45) {
      if (props.ischecked == true) {
        return (
          <>
            <div class="col-md-5">
              <div class="from   justify-content-between  align-items-center ">
                <label class="mr-1 mtop">- {props.name.split('Per')[0]}
                  <span class="question" onClick={() => showInfo(props.structureType + "-" + props.id)} > <svg xmlns="http://www.w3.org/2000/svg" width="15.339" height="17" fill="gray" >
                    <path d="M6.749,0A6.749,6.749,0,1,0,13.5,6.749,6.757,6.757,0,0,0,6.749,0Zm0,12.7A5.955,5.955,0,1,1,12.7,6.749,5.961,5.961,0,0,1,6.749,12.7Zm.919-3a.819.819,0,1,1-.819-.819A.82.82,0,0,1,7.669,9.7Zm.8-6.355A1.913,1.913,0,0,1,8.9,4.82,3,3,0,0,1,7.814,6.442,1.6,1.6,0,0,0,7.072,7.75H6.278a2.36,2.36,0,0,1,1-1.9,2.279,2.279,0,0,0,.846-1.214,1.187,1.187,0,0,0-.286-.8,1.2,1.2,0,0,0-.991-.465A1.324,1.324,0,0,0,5.364,4.652L4.57,4.631a2.118,2.118,0,0,1,2.281-2.05,2.017,2.017,0,0,1,1.614.766Z" />
                  </svg></span>

                </label>
              </div>
            </div>
            <div class="col-2 ismobile"></div>
            <div class="col-md-3 col-5">
              <div class="from   justify-content-between  align-items-center ">
                <div class="test">
                  <input

                    type="text"
                    key={props.structureType + "-" + props.id}
                    id={props.structureType + "-" + props.id}
                    value={value}
                    onChange={onChange}
                    //placeholder={props.name.split('Per')[0]}
                    style={{ backgroundColor: "#e7f0fa" }}

                    class={IsStyle}
                  />
                </div>
              </div>
            </div>
          </>
        );
      }
      else {
        return (
          <>
            <div class="col-md-5">
              <div class="from   justify-content-between  align-items-center ">
                <label class="mr-1 mtop">- {props.name.split('Per')[0]}
                  <span class="question" onClick={() => showInfo(props.structureType + "-" + props.id)} > <svg xmlns="http://www.w3.org/2000/svg" width="15.339" height="17" fill="gray" >
                    <path d="M6.749,0A6.749,6.749,0,1,0,13.5,6.749,6.757,6.757,0,0,0,6.749,0Zm0,12.7A5.955,5.955,0,1,1,12.7,6.749,5.961,5.961,0,0,1,6.749,12.7Zm.919-3a.819.819,0,1,1-.819-.819A.82.82,0,0,1,7.669,9.7Zm.8-6.355A1.913,1.913,0,0,1,8.9,4.82,3,3,0,0,1,7.814,6.442,1.6,1.6,0,0,0,7.072,7.75H6.278a2.36,2.36,0,0,1,1-1.9,2.279,2.279,0,0,0,.846-1.214,1.187,1.187,0,0,0-.286-.8,1.2,1.2,0,0,0-.991-.465A1.324,1.324,0,0,0,5.364,4.652L4.57,4.631a2.118,2.118,0,0,1,2.281-2.05,2.017,2.017,0,0,1,1.614.766Z" />
                  </svg></span>

                </label>
              </div>
            </div>
            <div class="col-2 ismobile"></div>
            <div class="col-md-3 col-5">
              <div class="from   justify-content-between  align-items-center ">
                <div class="test">
                  <input

                    type="text"
                    key={props.structureType + "-" + props.id}
                    id={props.structureType + "-" + props.id}
                    value={value}
                    onChange={onChange}
                    //placeholder={props.name.split('Per')[0]}


                    class={IsStyle}
                  />
                </div>
              </div>
            </div>
          </>
        );
      }
    }
    else if (props.id == 246) {
      if (props.ischecked == true) {
        return (
          <>

            <div class="col-md-2 col">
              <div class="from   justify-content-between  align-items-center ">
                <div class="test">
                  <input
                    type="text"
                    key={props.structureType + "-" + props.id}
                    id={props.structureType + "-" + props.id}
                    value={value}
                    onChange={onChange}
                    //placeholder={props.name.split('Per')[0]}
                    style={{ backgroundColor: "#e7f0fa" }}
                    class={IsStyle}

                  />
                </div>
              </div>
            </div>
          </>
        );
      }
      else {
        return (
          <>

            <div class="col-md-2 col">
              <div class="from   justify-content-between  align-items-center ">
                <div class="test">
                  <input
                    type="text"
                    key={props.structureType + "-" + props.id}
                    id={props.structureType + "-" + props.id}
                    value={value}
                    onChange={onChange}
                    //placeholder={props.name.split('Per')[0]}

                    class={IsStyle}

                  />
                </div>
              </div>
            </div>
          </>
        );

      }
    }
    else if (props.id == 280) {
      if (props.ischecked == true) {
        return (
          <>

            <div class="col-md-1 col-2" style={{ marginTop: "2%" }}>
              <div class="from   justify-content-between  align-items-center ">
                <div class="test2">
                  <input
                    type="text"
                    key={props.structureType + "-" + props.id}
                    id={props.structureType + "-" + props.id}
                    value={value}
                    onChange={onChange}
                    //placeholder={props.name.split('Per')[0]}
                    style={{ backgroundColor: "#e7f0fa" }}
                    class={IsStyle}

                  />
                </div>
              </div>
            </div>
          </>
        );
      }
      else {
        return (
          <>

            <div class="col-md-1 col-2" style={{ marginTop: "2%" }}>
              <div class="from   justify-content-between  align-items-center ">
                <div class="test2">
                  <input
                    type="text"
                    key={props.structureType + "-" + props.id}
                    id={props.structureType + "-" + props.id}
                    value={value}
                    onChange={onChange}
                    //placeholder={props.name.split('Per')[0]}
                    // style={{padding:"0rem !important"}}
                    class={IsStyle}

                  />
                </div>
              </div>
            </div>
          </>
        );
      }
    }
    else if (props.id == 181) {
      if (props.ischecked == true) {
        return (
          <>

            <div class="col-md-1 col-2">
              <div class="from   justify-content-between  align-items-center ">
                <div class="test2">
                  <input
                    type="text"
                    key={props.structureType + "-" + props.id}
                    id={props.structureType + "-" + props.id}
                    value={value}
                    onChange={onChange}
                    //placeholder={props.name.split('Per')[0]}
                    style={{ backgroundColor: "#e7f0fa" }}
                    class={IsStyle}

                  />
                </div>
              </div>
            </div>
          </>
        );
      }
      else {
        return (
          <>

            <div class="col-md-1 col-2">
              <div class="from   justify-content-between  align-items-center ">
                <div class="test2">
                  <input
                    type="text"
                    key={props.structureType + "-" + props.id}
                    id={props.structureType + "-" + props.id}
                    value={value}
                    onChange={onChange}
                    //placeholder={props.name.split('Per')[0]}
                    // style={{padding:"0rem !important"}}
                    class={IsStyle}

                  />
                </div>
              </div>
            </div>
          </>
        );
      }
    }
    else {
      return (
        <>

          <div class="col-md-3 col-5">
            <div class="from   justify-content-between  align-items-center ">
              <div class="test">
                <input
                  type="text"
                  key={props.structureType + "-" + props.id}
                  id={props.structureType + "-" + props.id}
                  value={value}
                  onChange={onChange}
                  //placeholder={props.name.split('Per')[0]}
                  readOnly
                  class={IsStyle}
                />
              </div>
            </div>
          </div>
        </>
      );
    }
  }



  else {

    return (
      <>
        <div class="col-md-3 ">
          <div class="from   justify-content-between  align-items-center ">
            <label class="mr-1 mtop">{props.name.split('Per')[0]}
              <span class="question" onClick={() => showInfo(props.structureType + "-" + props.id)} > <svg xmlns="http://www.w3.org/2000/svg" width="15.339" height="17" fill="gray" >
                <path d="M6.749,0A6.749,6.749,0,1,0,13.5,6.749,6.757,6.757,0,0,0,6.749,0Zm0,12.7A5.955,5.955,0,1,1,12.7,6.749,5.961,5.961,0,0,1,6.749,12.7Zm.919-3a.819.819,0,1,1-.819-.819A.82.82,0,0,1,7.669,9.7Zm.8-6.355A1.913,1.913,0,0,1,8.9,4.82,3,3,0,0,1,7.814,6.442,1.6,1.6,0,0,0,7.072,7.75H6.278a2.36,2.36,0,0,1,1-1.9,2.279,2.279,0,0,0,.846-1.214,1.187,1.187,0,0,0-.286-.8,1.2,1.2,0,0,0-.991-.465A1.324,1.324,0,0,0,5.364,4.652L4.57,4.631a2.118,2.118,0,0,1,2.281-2.05,2.017,2.017,0,0,1,1.614.766Z" />
              </svg></span>
            </label>



          </div>
        </div>
        <div class="col-md-3 col-5">
          <div class="from   justify-content-between  align-items-center ">
            <div class="test">
              <input
                type="text"
                key={props.structureType + "-" + props.id}
                id={props.structureType + "-" + props.id}
                value={value}
                onChange={onChange}
                //placeholder={props.name.split('Per')[0]}

                class={IsStyle}

              />
            </div>
          </div>
        </div>
      </>
    );
  }
}
export default LandAnalysis;
